__webpack_public_path__ = window.__webpack_public_path__;

import 'regenerator-runtime/runtime';
//import './bootstrap';
import '../scss/app.scss';
import Controller from './controllers/Controller';
import CheckoutHandler from './components/CheckoutHandler';
import CourseListHandler from './components/CourseListHandler';

export default class App {
  init() {
      //now controller will handle dynamic imports from lists, read line 50
      const controller = new Controller();
      this.importPageHandlers();
  }

  // setupServiceWorker(){
  //   console.log("setup ServiceWorker");
  //   if ('serviceWorker' in navigator) {
  //     window.addEventListener('load', () => {
  //       navigator.serviceWorker.register('./service-worker.js').then(registration => {
  //         console.log('SW registered: ', registration);
  //       }).catch(registrationError => {
  //         console.log('SW registration failed: ', registrationError);
  //       });
  //     });
  //   }
  // }

    //TODO : commented because of bug explained at line 50
//  importController() {
//    let pageType = document.querySelector('html');
//    let controller =
//      (pageType && pageType.dataset.controller && pageType.dataset.controller !== "")
//      ? pageType.dataset.controller
//      : "Controller";
//    console.log('CONTROLLER: ',controller);
//
//    import(/* webpackChunkName:`controller-[request]` *//* webpackMode: "lazy" */`./controllers/${controller}`
//    ).then(async ({ default: controller }) => {
//      new controller();
//    }).catch(error => {
//      console.error("No data-controller detected on html tag");
//      console.dir(error);
//    });
//  }

    //This until we find a way to refactor as clean as possible,
    // these are components handling entire page not single component/s
    //Laravel mix are not handling as expected the nested (into controllers) dynamic imports
  importPageHandlers() {
      let pageType = document.querySelector('html');
      if (pageType.dataset && pageType.dataset.pageType!==''){
          switch (pageType.dataset.pageType){
              case 'CheckoutPage':
                  const checkOutHandler = new CheckoutHandler();
                  break;
              case 'CourseListPage':
                  const courseListHandler = new CourseListHandler();
          }
      }
  }
}

let app = new App();
app.init();
